import store from '../store';

export function isAuthed() {
  return store.state.users.token != '';
};

export function formatDateTime(date) {
  if (date) {
    let dateObj = new Date(date);
    let dateString = dateObj.toDateString();
    let dateParts = dateString.split(' ');
    let timeString = dateObj.toLocaleTimeString();
    let timeParts = timeString.split(':');
    
    return timeParts[0]+':'+timeParts[1]+' - '+dateParts[2]+' '+dateParts[1]+' '+dateParts[3];
  }
  return '-';
}

export function formatDate(date) {
  if (date) {
    let dateObj = new Date(date);
    let dateString = dateObj.toDateString();
    let dateParts = dateString.split(' ');

    return dateParts[2] + ' ' + dateParts[1] + ' ' + dateParts[3];
  }
  return '-';
}

export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}